<template>
  <div>
    <v-card flat>
      <v-card-title>
        L24000000004
      </v-card-title>
      <v-card-subtitle>
        Rua Marina Moura, 466 - Parque São Paulo, Casa Branca
      </v-card-subtitle>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Betoneira (x10)
              <v-btn icon color="red"> <v-icon>mdi-close</v-icon> </v-btn>
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-select
                hide-details
                outlined
                dense
                label="Local de origem"
              ></v-select>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-text-field
                value="10"
                label="Qtd"
                single-line
                type="number"
                hide-details
                outlined
                dense
                style="width: 150px"
              ></v-text-field>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Escora (x1000)
              <v-btn icon color="red"> <v-icon>mdi-close</v-icon> </v-btn>
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-select
                hide-details
                outlined
                dense
                label="Local de origem"
              ></v-select>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-text-field
                value="1000"
                label="Qtd"
                single-line
                type="number"
                hide-details
                outlined
                dense
                style="width: 150px"
              ></v-text-field>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined>Confirmar</v-btn>
      </v-card-actions>
    </v-card>

    <v-divider></v-divider>

    <v-card class="mt-2" flat>
      <v-card-title>
        L24000000005
      </v-card-title>
      <v-card-subtitle>
        Rua Marina Moura, 466 - Parque São Paulo, Casa Branca
      </v-card-subtitle>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Betoneira (x10)
              <v-btn icon color="red"> <v-icon>mdi-close</v-icon> </v-btn>
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-select
                hide-details
                outlined
                dense
                label="Local de origem"
              ></v-select>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-text-field
                value="10"
                label="Qtd"
                single-line
                type="number"
                hide-details
                outlined
                dense
                style="width: 150px"
              ></v-text-field>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined>Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  methods: {},

  computed: {}
};
</script>
